import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d8e3a16")

_pushScopeId("data-v-2d8e3a16")
const _hoisted_1 = { class: "p-m-3" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  for: "dataSourceLabel",
  class: "kn-material-input-label"
}
const _hoisted_4 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_Card = _resolveComponent("Card")
  const _component_MeasureDefinitionPreviewDialog = _resolveComponent("MeasureDefinitionPreviewDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, null, {
      content: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, [
            _createVNode(_component_Dropdown, {
              id: "dataSource",
              class: "kn-material-input",
              modelValue: _ctx.selectedRule.dataSource,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedRule.dataSource = $event)),
              options: _ctx.datasourcesList,
              optionLabel: "DATASOURCE_LABEL",
              onChange: _ctx.loadDataSourceStructure
            }, null, 8, ["modelValue", "options", "onChange"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('kpi.measureDefinition.dataSource')), 1)
          ])
        ]),
        (_ctx.selectedRule.dataSource)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
                end: _withId(() => [
                  _createVNode(_component_Button, {
                    class: "kn-button p-button-text p-button-rounded",
                    onClick: _ctx.showPreview,
                    disabled: _ctx.previewDisabled
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('kpi.measureDefinition.preview')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_VCodeMirror, {
                ref: "codeMirror",
                value: _ctx.code,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.code = $event)),
                autoHeight: true,
                options: _ctx.options,
                onKeyup: _ctx.onKeyUp
              }, null, 8, ["value", "options", "onKeyup"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.preview)
      ? (_openBlock(), _createBlock(_component_MeasureDefinitionPreviewDialog, {
          key: 0,
          currentRule: _ctx.selectedRule,
          placeholders: _ctx.placeholders,
          columns: _ctx.columns,
          propRows: _ctx.rows,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closePreview'))),
          onLoadPreview: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('loadPreview')))
        }, null, 8, ["currentRule", "placeholders", "columns", "propRows"]))
      : _createCommentVNode("", true)
  ], 64))
})